import React from 'react';
import { Container, Button, Badge } from '../design-system';
import { ArrowRight, CheckCircle, Sparkles } from 'lucide-react';

interface HeroProps {
  onContactClick: () => void;
}

export function Hero({ onContactClick }: HeroProps) {
  return (
    <section id="hero" className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-200/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      <Container maxWidth="xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center relative">
          <div className="text-center lg:text-left">
            <Badge variant="primary" className="mb-6">
              <Sparkles className="w-3 h-3" />
              Inovação em Software
            </Badge>
            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
              Transforme seus problemas em{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
                soluções digitais
              </span>
            </h1>
            <p className="text-xl text-slate-600 mb-8 max-w-2xl">
              A Gruty é especializada em resolver problemas reais com soluções digitais, feitas de maneira organizada, objetiva e segura — desde o entendimento do problema até a solução.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-slate-700">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>Processo organizado</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>Entregas objetivas</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span>Arquitetura segura</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button size="lg" onClick={onContactClick}>
                Começar Agora
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button size="lg" variant="outline">
                Ver Portfólio
              </Button>
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <picture>
                <source
                  type="image/avif"
                  srcSet="
                    https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=avif&q=70&w=480 480w,
                    https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=avif&q=70&w=665 665w,
                    https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=avif&q=70&w=960 960w
                  "
                  sizes="(min-width:1024px) 665px, 100vw"
                />
                <source
                  type="image/webp"
                  srcSet="
                    https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=webp&q=70&w=480 480w,
                    https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=webp&q=70&w=665 665w,
                    https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=webp&q=70&w=960 960w
                  "
                  sizes="(min-width:1024px) 665px, 100vw"
                />
                <img
                  src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?fm=jpg&q=80&w=665"
                  alt="Software Development Team"
                  className="w-full h-auto"
                  width={665}
                  height={456}
                  decoding="async"
                  fetchPriority="high"
                />
              </picture>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
